import { Children, isValidElement } from 'react';
import * as stylex from '@stylexjs/stylex';
import { List, ListItem } from 'foundations-components/transitional/components/List';
import { useUiVariant } from './UiVariantProvider';
import { toMarginXstyle, toPaddingXstyle } from './utils/foundationsSpacing';
import { jsx as _jsx } from "react/jsx-runtime";
// Trellis has no bulleted list component (its experimental List is always
// unstyled), and its docs recommend plain ul/li for lists with markers.
const styles = {
  list: {
    boxSizing: "x9f619",
    marginBlock: "x10im51j",
    marginInline: "xrxpjvj",
    $$css: true
  },
  unstyled: {
    listStyleType: "x3ct3a4",
    paddingInlineStart: "x1c1uobl",
    $$css: true
  },
  styled: {
    listStyleType: "xtaz4m5",
    $$css: true
  },
  item: {
    boxSizing: "x9f619",
    margin: "x1ghz6dp",
    padding: "x1717udv",
    $$css: true
  },
  marginBlockEnd50: {
    marginBottom: "xjpr12u",
    $$css: true
  }
};
const TrellisListItem = ({
  children,
  marginBlockEnd,
  'data-test-id': dataTestId
}) => /*#__PURE__*/_jsx("li", Object.assign({
  "data-test-id": dataTestId
}, stylex.props(styles.item, marginBlockEnd === '50' ? styles.marginBlockEnd50 : toMarginXstyle({
  marginBlockEnd
})), {
  children: children
}));
const TrellisList = ({
  'aria-label': ariaLabel,
  children,
  marginBlockEnd,
  paddingInlineStart,
  styled = false,
  wrapChildren = false
}) => {
  const items = Children.toArray(children);
  return /*#__PURE__*/_jsx("ul", Object.assign({
    "aria-label": ariaLabel
  }, stylex.props(styles.list, styled ? styles.styled : styles.unstyled, toMarginXstyle({
    marginBlockEnd
  }), toPaddingXstyle({
    paddingInlineStart
  })), {
    children: wrapChildren ? items.map((child, index) => {
      var _child$key;
      return /*#__PURE__*/_jsx(TrellisListItem, {
        children: child
      }, /*#__PURE__*/isValidElement(child) ? (_child$key = child.key) !== null && _child$key !== void 0 ? _child$key : index : index);
    }) : items
  }));
};
export const CdpList = props => {
  const variant = useUiVariant();
  return variant === 'trellis' ? /*#__PURE__*/_jsx(TrellisList, Object.assign({}, props)) : /*#__PURE__*/_jsx(List, Object.assign({}, props));
};
export const CdpListItem = props => {
  const variant = useUiVariant();
  return variant === 'trellis' ? /*#__PURE__*/_jsx(TrellisListItem, Object.assign({}, props)) : /*#__PURE__*/_jsx(ListItem, Object.assign({}, props));
};